import { captureException } from "@sentry/react"

import { createCaptureError } from "@productlane/lib/src/sentry"

export const captureError = createCaptureError(captureException, "app")
